// Tipovi i konstante
import { OfferSearchPageCmp, OfferSearchPageProps } from "./types";

// UI komponente
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";

// Moduli specifični za projekt
import { Routes } from "ui/modules/finance/navigation";

// Lokalne komponente
import OfferSaleSearchPage from "./components/OfferSaleSearchPage/OfferSaleSearchPage";
import OfferRentSearchPage from "./components/OfferRentSearchPage/OfferRentSearchPage";
import { OFFER_SEARCH_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { useTranslate } from "helpers";
import { Tabs } from "ui/components/Tabs";
import { Breadcrumb } from "ui/components/Breadcrumb";



const OfferSearchPage: OfferSearchPageCmp = (
  props: OfferSearchPageProps
) => {

  const { t } = useTranslate();

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md border border-b mb-2">
          <PageHeader>
            <div className="flex gap-3">
              <div>
                <PageTitle
                  title={`${t(OFFER_SEARCH_PAGE_TITLE.text)}`}
                  icon={OFFER_SEARCH_PAGE_TITLE.icon}
                  iconColor={OFFER_SEARCH_PAGE_TITLE.iconColor}
                />
                <Breadcrumb />
              </div>
            </div>
          </PageHeader>
        </div>
        <Tabs
          tabs={[
            {
              label: t("admin.finance.offer.search.tab.sale"),
              queryParam: "sale",
              content: (
                <div>
                  <OfferSaleSearchPage />
                </div>
              ),
            },
            {
              label: t("admin.finance.offer.search.tab.rent"),
              queryParam: "rent",
              content: (
                <div>
                  <OfferRentSearchPage />
                </div>
              ),
            },
            {
              label: t("admin.finance.offer.search.tab.stats"),
              queryParam: "stats",
              content: (
                <div>

                </div>
              ),
            },
          ]}
        />

      </div>

    </>
  );
};

OfferSearchPage.route = Routes.OfferSearchPageRouter;

export default OfferSearchPage;
